// Deaktiver Ring Meg for en periode
export function callbackFunctionIsDisabled() {
	return false;
	// const now = new Date();
	// const start = new Date("2023-12-21");
	// const end = new Date("2024-01-02");
	// return now >= start && now <= end;
}
